import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const InvitationAPI = {
  getInvitationsList: async (token, queryParams = {}) => {
    return await axios({
      method: "GET",
      url: `${BACKEND_ORIGIN}/api/invitation/list`,
      headers: { Authorization: token },
      params: { ...queryParams },
    });
  },
};

export default InvitationAPI;
